import React from 'react';

import { correctingTrailingNumbers, removeTrailingZeros } from '@cryptoboyio/mercuryo-lab/utils';

import { bemCssModules, getFormattedFiatCurrencyNumber } from '@utils';
import { useFiatCurrency, useTotalDigits } from '@utils/hooks';

import { CryptoCurrencyEnum, FiatCurrencyEnum } from '@modules/global/types';

import style from './Balance.scss';

const cn = bemCssModules(style, 'Balance');

export type TBalance = {
  crypto: {
    balance?: string;
    currency: CryptoCurrencyEnum;
  };
  fiat: {
    balance?: string;
    currency?: FiatCurrencyEnum;
  };
};

const Balance: CustomFC<TBalance> = ({ crypto, fiat, className }) => {
  const { getTotalDigits, getDisplayDigits } = useTotalDigits();
  const defaultFiatCurrency = useFiatCurrency();
  const fiatCurrency = fiat?.currency || defaultFiatCurrency;

  const fiatBalance = correctingTrailingNumbers(
    fiat?.balance || 0,
    getDisplayDigits(fiatCurrency),
    getTotalDigits(fiatCurrency)
  );

  const cryptoBalance = correctingTrailingNumbers(
    crypto?.balance || 0,
    getDisplayDigits(crypto.currency)
  );

  const formattedFiatCurrency = getFormattedFiatCurrencyNumber({
    amount: Number(fiatBalance),
    currency: fiatCurrency,
  });

  return (
    <div className={cn(null, [className])}>
      <div className={cn('crypto')}>
        {removeTrailingZeros(cryptoBalance)} {crypto.currency}
      </div>
      <div className={cn('fiat')}>{formattedFiatCurrency}</div>
    </div>
  );
};

export default Balance;
